import { BookingObject } from 'src/types';

import { DeskBookingFilters, DesksState } from './types';

export const emptyBookingObjects = new Map<string, BookingObject>();
export const defaultDeskBookingFilters: DeskBookingFilters = {
  byWindow: false,
  withMonitor: false,
  withCharger: false,
  withDivider: false,
};
export const emptyDates = new Set<string>();

export const initialState: DesksState = {
  loading: false,
  locationLoading: false,
  bookingObjects: emptyBookingObjects,
  staticObjects: emptyBookingObjects,
  date: undefined,
  filters: defaultDeskBookingFilters,
  ...defaultDeskBookingFilters,
  excludedDates: emptyDates,
  currentRequestId: undefined,
  deskBookingSheetIsOpened: false,
};
